import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../auth/AuthProvider";
import { getConfig } from "../config";
import { getUserManager } from "../auth/userManager";
import { AuthPageShell } from "../components/AuthPageShell";
import { Spinner } from "../components/Spinner";

export function LoggedOutPage() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const config = getConfig();
  const showEnvPicker = config.SHOW_ENV_PICKER && !sessionStorage.getItem("sfEnv");
  const [ready, setReady] = useState(false);

  useEffect(() => {
    getUserManager().removeUser()
      .catch(() => {}) // Storage error is non-critical — still let the user proceed
      .finally(() => setReady(true));
  }, []);

  if (!ready) return <Spinner overlay />;

  return (
    <AuthPageShell showSignOut={false}>
      <svg className="mx-auto mb-4 h-12 w-12 text-gray-400" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" strokeLinecap="round" strokeLinejoin="round">
        <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" />
        <polyline points="16 17 21 12 16 7" />
        <line x1="21" y1="12" x2="9" y2="12" />
      </svg>

      <h2 className="text-xl font-bold text-gray-900 mb-2 text-center">Logged Out</h2>
      <p className="text-sm text-gray-500 mb-6 text-center">You have been successfully logged out.</p>

      <button
        onClick={() => showEnvPicker ? navigate("/env") : login()}
        className="w-full rounded-lg bg-brand-green px-4 py-3 text-white font-semibold hover:bg-brand-green-dark transition-colors cursor-pointer"
      >
        Log in again
      </button>
    </AuthPageShell>
  );
}
